import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Portlet, PortletBody } from 'components/partials/content/Portlet';
import PorletHeader, { PorletHeaderTitle } from 'components/porletHeader';
import { getBuildingTopNeed } from 'redux/dashboard/selector';

import Table from './table';

const BuildingNeedProject = ({ data, isLoading }) => (
  <Portlet className="kt-portlet--height-fluid">
    <PorletHeader>
      <PorletHeaderTitle>
        <FormattedMessage id="Proyecto por tipo de necesidad" />
      </PorletHeaderTitle>
    </PorletHeader>
    <PortletBody>
      {!isLoading && (
        <>
          <Table data={data} />
          <div className="kt-space-20" />
        </>
      )}
    </PortletBody>
  </Portlet>
);
export default connect(getBuildingTopNeed)(BuildingNeedProject);
